export default __webpack_public_path__ + "static/media/WELL.b011803d.png";